import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { withRouter, Link } from 'react-router'
import Logo from '../../base/components/Logo'
import Price from '../../base/components/Price'
import Icon from '../../../shared/components/Icon'
import Bool from '../../shared/components/Bool'
import DateValue from '../../shared/components/DateValue'
import CommaSeparatedList from '../../shared/components/CommaSeparatedList'
import ValueList from '../../shared/components/ValueList'
import createImageUrl from '../../shared/createImageUrl'
import getPath from '../../../shared/utils/getPath'
import { toImageSet, imagesByType } from '../../../shared/utils/images'
import { API_SERVER_URL } from '../../../config'
import FileList from '../../../shared/components/FileList'

@withRouter
export default class GuidedTourDetailsContainer extends Component {

  static propTypes = {
    guidedTour: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }),
    router: PropTypes.object.isRequired,
  }

  @autobind
  handleGoBack() {
    this.props.router.goBack()
  }

  render() {

    const entry = this.props.guidedTour
    if (!entry) {
      return null
    }

    let region = ''
    try {
      region = window.APP_CONFIG.list_region
        .find(({ id }) => id === entry.museum.address.region * 1)
        .title
    }
    catch (er) {
      console.warn('Invalid region')
    }

    const { bannerImage, otherImages } = imagesByType(entry.images || [])

    return (
      <div className="row no-margin detail">

        <div className="col-md-3 col-xs-12">
          <div className="app-sidebar">
            <div className="clearfix">
              <Logo />

              {bannerImage
                ? (
                  <div className="banner-container">
                    <div className="banner"
                      style={{ backgroundImage: `url(${createImageUrl(bannerImage, 600)})` }}
                    />
                    <div className="image-description">
                      {bannerImage.pivot && bannerImage.pivot.description
                        ? bannerImage.pivot.description
                        : null}
                    </div>
                  </div>
                )
                : null}

              {toImageSet(otherImages)
                .map(({ index, set }) => {
                  return (
                    <div key={index} className="other-images clearfix">
                      {set.map((image) => {
                        return (
                          <div key={image.url} className="small banner-container">
                            <div className="banner"
                              style={{ backgroundImage: `url(${createImageUrl(image, 600)})` }}
                            />
                            <div className="image-description">
                              {image.pivot && image.pivot.description
                                ? image.pivot.description
                                : null}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )
                })}
            </div>

          </div>
        </div>

        <div className="col-md-9 col-xs-12">

          <h2>
            <Icon
              size={24}
              style={{ marginBottom: '-3px' }}
              name="guided-tour"
            />
            {entry.title}
          </h2>

          <div className="row action-bar">

            <div className="col-xs-12">
              <button
                className="btn btn-small btn-primary"
                onClick={this.handleGoBack}
              >
                <i className="glyphicon glyphicon-chevron-left" />
                {' '}
                Zurück
              </button>
              &nbsp;
              <a
                href={`${API_SERVER_URL}print/guidedTour/${entry.id}`}
                className="btn btn-small btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="glyphicon glyphicon-print" />
                {' '}
                Drucken
              </a>
            </div>

          </div>

          {entry.temporarilyNotBookable ? (
            <div className="row">
              <div className="col-xs-12 warn-block">
                <Icon
                  name="virus-turquoise"
                  size="26"
                />
                {entry.temporarilyNotBookableReason || 'Temporär nicht buchbar'}
              </div>
            </div>
          ) : null}

          <div className="row">

            <div className="col-md-6 col-sm-8 col-xs-12">

              <div className="row">

                <div className="col-xs-12">

                  <h4>Informationen:</h4>

                  {entry.description}

                  <ul className="list-unstyled" />

                </div>

              </div>

              <div className="row">

                <div className="col-md-6 col-xs-12">

                  Programmdauer:
                  {' '}
                  {entry.duration}
                  {' '}
                  Minuten
                  <br />
                  Teilnehmende: maximal
                  {' '}
                  {entry.maxParticipants}
                  <br />

                  <h4>Buchung</h4>
                  buchbar von
                  {' '}
                  <DateValue value={entry.bookingStart} />
                  {' '}
                  bis zum
                  {' '}
                  <DateValue value={entry.bookingEnd} />
                  <br />
                  <Bool
                    value={entry.bookableOutOfOpeningTimes}
                    truthy="<strong>auch</strong>"
                    falsy="<strong>nicht</strong>"
                  />
                  {' '}
                  außerhalb der Museumsöffnungszeiten
                  <br />
                  <br />

                  an folgenden Wochentagen:
                  <br />

                  <CommaSeparatedList list={entry.days} type="day" />

                  <h4>Kosten</h4>

                  {parseInt(entry.generalPrice, 10) * 1 > 0 ? (
                    <span>
                      Pauschalpreis:{' '}
                      <Price value={entry.generalPrice} />
                      <br />
                    </span>
                  ) : null}
                  {parseInt(entry.minPrice, 10) * 1 > 0 ? (
                    <span>
                      Mindestbetrag:{' '}
                      <Price value={entry.minPrice} />
                      <br />
                    </span>
                  ) : null}
                  {parseInt(entry.costsByPerson, 10) * 1 > 0
                    ? (
                      <span>
                        Preis pro Schüler:{' '}
                        <Price value={entry.costsByPerson} />
                        <br />
                      </span>
                    )
                    : null}

                  <Bool
                    value={entry.specialConditionsForRemedialClasses}
                    truthy=""
                    falsy="<strong>keine</strong>"
                  />
                  {' '}
                  gesonderte Konditionen für Förderklassen
                  <br />

                  <Bool
                    value={entry.freeEntryForTeachersAtPrevisit}
                    truthy=""
                    falsy="<strong>kein</strong>"
                  />
                  {' '}
                  freier Eintritt für Lehrkräfte bei Vorbesuchen
                  <br />

                  <h4>Angebotene Sprachen</h4>
                  <CommaSeparatedList list={entry.languages} type="languages" />
                </div>

              </div>

            </div>

            <div className="col-md-3 col-sm-4 col-xs-12 ">

              <h4>Schule:</h4>
              <ValueList list={entry.schools} type="school" />

              <h4>Lehrplanbezug:</h4>
              <div>
                <pre>
                  {entry.curriculums}
                </pre>
              </div>

              <h4>Jahrgang:</h4>

              <CommaSeparatedList list={entry.grades} type="grade" />

              <h4>Schulfächer:</h4>
              <ValueList list={entry.subjects} type="subject" />

              {entry.links ? (
                <div>
                  <h4>Links und Downloads:</h4>
                  <FileList
                    list={entry.links}
                    type="file"
                  />
                </div>
              ) : null}

            </div>

            <div className="col-md-3 col-sm-4 col-xs-12">

              <div className="info-box">

                <div>
                  <svg
                    width="30"
                    height="30"
                  >
                    <use xlinkHref="#icon-house-white" />
                  </svg>
                </div>

                <h3>
                  <Link to={getPath(
                    'frontend',
                    'museum',
                    entry.museum.id
                  )}
                  >
                    {entry.museum.name}
                  </Link>
                </h3>

                {entry.museum.address.street}
                {' '}
                {entry.museum.address.number}
                <br />
                {entry.museum.address.zip}&nbsp;
                {entry.museum.address.location}
                <br />
                {region}
                <br />
                <br />
                Telefon:
                {' '}
                {entry.museum.phone || '-'}
                <br />
                Fax:
                {' '}
                {entry.museum.fax || '-'}
                <br />
                <a href={`mailto:${entry.museum.email || '-'}`}>E-Mail-Kontakt</a>
                <br />
                <a
                  href={entry.museum.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Museumswebsite besuchen
                </a>
              </div>
              {entry.hostelUrl
                ? (
                  <div style={{ marginTop: '60px' }}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={entry.hostelUrl}
                    >
                      <img
                        alt="Jugendgerberge"
                        src="/static/images/djh.png"
                      />
                    </a>
                  </div>
                )
                : null}
            </div>
          </div>

        </div>

      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/guided-tour/components/Details.js